const circle = {
    fill: "none",
    strokeWidth: "2.8",
    strokeLinecap: "round",
    animation: "progress 1.7s ease-out forwards",
};
const percentageStyle = {
    fontSize: "7px",
    fontWeight: "700",
    textAnchor: "middle"
};

export { circle, percentageStyle };
